import { queryOptions } from "@tanstack/react-query";

import {
  getSettingsBillingInvoices,
  getSettingsBillingPlans,
  getSettingsHeaderRetentionView,
  getSettingsUsageOverview,
} from "./server-fns";
export function settingsHeaderRetentionQueryKey() {
  return ["settingsHeaderRetention"] as const;
}

export function settingsHeaderRetentionQueryOptions() {
  return queryOptions({
    queryKey: settingsHeaderRetentionQueryKey(),
    queryFn: () => getSettingsHeaderRetentionView(),
    staleTime: 30_000,
  });
}

export function settingsUsageOverviewQueryKey() {
  return ["settingsUsageOverview"] as const;
}

export function settingsUsageOverviewQueryOptions() {
  return queryOptions({
    queryKey: settingsUsageOverviewQueryKey(),
    queryFn: () => getSettingsUsageOverview(),
    staleTime: 30_000,
  });
}

export function settingsBillingInvoicesQueryKey() {
  return ["settingsBillingInvoices"] as const;
}

export function settingsBillingInvoicesQueryOptions() {
  return queryOptions({
    queryKey: settingsBillingInvoicesQueryKey(),
    queryFn: () => getSettingsBillingInvoices(),
    staleTime: 30_000,
  });
}

export function settingsBillingPlansQueryKey() {
  return ["settingsBillingPlans"] as const;
}

export function settingsBillingPlansQueryOptions() {
  return queryOptions({
    queryKey: settingsBillingPlansQueryKey(),
    queryFn: () => getSettingsBillingPlans(),
    staleTime: 30_000,
  });
}
